import React from 'react';
import { useNavigate } from 'react-router-dom';

function CotisationJoueur(props) {
  const Navigate = useNavigate();


  return (
    <>
    {props.userData && (
    <>
      <h2>Cotisation</h2>

      <div className="card-body">
          <div className="ajout">
              <form className="Invite_Joueur">
                  <div>
                      En tant que joueur, assurez-vous que votre cotisation est à jour pour continuer à jouer avec votre équipe. Payez dès maintenant pour rester pleinement engagé dans vos activités et événements !
                  </div>
                  <br />
                  <button type="submit" style={{ margin: "auto" }} onClick={() => Navigate('/joueurs/accueil/cotisation')} className="conect">
                      Payer ma cotisation
                  </button>
              </form>
          </div>
      </div>

    </>
    )}
    </>
  );
}

export default CotisationJoueur;
